<section class="md-page">
  <p-toast></p-toast>
  <p-confirmDialog [style]="{ width: '450px' }"></p-confirmDialog>

  <div class="md-list-shell">
    <div class="flex align-items-center justify-content-between mb-3">
      <h2 class="m-0">Customers</h2>
      <div class="flex gap-2">
        <p-button label="Export" icon="pi pi-file-excel" styleClass="p-button-help" (click)="exportExcel()"></p-button>
      </div>
    </div>

    <div class="mb-4 p-4 border-round-2xl bg-gray-100">
      <form [formGroup]="filterForm" (ngSubmit)="onSearch()">
        <div class="grid formgrid p-fluid">
          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-user"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="customerName" id="customerNameFilter" class="w-full" />
                <label for="customerNameFilter">Customer Name</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>

          <div class="field col-12 md:col-6 lg:col-4">
            <p-inputgroup>
              <p-inputgroup-addon><i class="pi pi-hashtag"></i></p-inputgroup-addon>
              <p-iftalabel>
                <input pInputText formControlName="customerNumber" id="customerNumberFilter" class="w-full" />
                <label for="customerNumberFilter">Customer Number</label>
              </p-iftalabel>
            </p-inputgroup>
          </div>
        </div>

        <div class="flex justify-content-end gap-2 mt-4">
          <p-button label="Reset" icon="pi pi-refresh" styleClass="p-button-secondary" type="button"
            (onClick)="onReset()"></p-button>
          <p-button label="Search" icon="pi pi-search" type="submit"></p-button>
        </div>
      </form>
    </div>

    <p-table #dt [value]="customers" [rows]="10" [paginator]="true" [totalRecords]="totalRecords"
      (onLazyLoad)="loadCustomers($event)" [loading]="isLoading" [lazy]="true" dataKey="id"
      styleClass="p-datatable-striped md-data-table">
      <ng-template pTemplate="header">
        <tr>
          <th pSortableColumn="customerName" style="min-width: 15rem">
            Customer Name <p-sortIcon field="customerName"></p-sortIcon>
          </th>
          <th pSortableColumn="customerNumber" style="min-width: 15rem">
            Customer Number <p-sortIcon field="customerNumber"></p-sortIcon>
          </th>
          <th pSortableColumn="erpCustomerId" style="min-width: 15rem">
            ERP Customer ID <p-sortIcon field="erpCustomerId"></p-sortIcon>
          </th>
          <th pSortableColumn="orgId" style="min-width: 10rem">
            Org ID <p-sortIcon field="orgId"></p-sortIcon>
          </th>
          <th pSortableColumn="status" style="min-width: 10rem">
            Status <p-sortIcon field="status"></p-sortIcon>
          </th>
          <th pSortableColumn="calculationMethod" style="min-width: 12rem">
            Calculation Method <p-sortIcon field="calculationMethod"></p-sortIcon>
          </th>
          <th style="min-width: 10rem">Actions</th>
        </tr>

      </ng-template>
      <ng-template pTemplate="body" let-customer>
        <tr>
          <td>{{ customer.customerName }}</td>
          <td>{{ customer.customerNumber ?? null }}</td>
          <td>{{ customer.erpCustomerId ?? null }}</td>
          <td>{{ customer.orgId ?? null }}</td>
          <td>{{ customer.status ?? null }}</td>
          <td>{{ customer.calculationMethod ?? null }}</td>
          <td>
            <div class="flex gap-2">
              <p-button icon="pi pi-trash" styleClass="p-button-rounded p-button-danger"
                (onClick)="deleteCustomer(customer.id)"></p-button>
            </div>
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="6">No Customers found.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</section>